import { useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { addSuccess, addDanger
// @ts-expect-error untyped-module
} from 'customer-data-ui-utilities/alerts/Alerts';
import QuotesLogger from 'quotes-ui-lib/tracking/quotesLogger';
import { getQuoteProperty } from 'quotes-ui-lib/utils/quote';
import * as QuotesActions from 'quotes-ui-lib/store/QuotesActions';
import { getIsPublishing } from 'quotes-ui-lib/utils/status';
import { getHasDeal } from 'quotes-ui-lib/utils/quote';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const CloneButton = ({
  quote,
  trackingLocation,
  buttonRef,
  onCloningSucceed
}) => {
  const [isCloning, setIsCloning] = useState(false);
  const [isCloningFailed, setIsCloningFailed] = useState(false);
  const handleButtonClick = useCallback(() => {
    QuotesLogger.log('quoteInteraction', {
      action: 'Clone quote',
      location: trackingLocation
    });
    setIsCloningFailed(false);
    setIsCloning(true);
    QuotesActions.cloneQuote(quote).then(clonedQuote => {
      addSuccess('quotesUiLib.cloneButton.successMessage', undefined, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "quotesUiLib.cloneButton.successTitle"
        })
      });
      if (onCloningSucceed) {
        onCloningSucceed(clonedQuote);
      }
    }).catch(() => {
      setIsCloningFailed(true);
      addDanger('quotesUiLib.cloneButton.errorMessage', undefined, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "quotesUiLib.cloneButton.errorTitle"
        })
      });
    }).finally(() => {
      setIsCloning(false);
    });
  }, [onCloningSucceed, quote, trackingLocation]);
  return (
    /*#__PURE__*/
    // Migrate when fixed: https://git.hubteam.com/HubSpot/foundations-components/issues/5923
    _jsx(UILoadingButton, {
      "data-test-id": "clone-quote-button",
      use: "tertiary-light",
      responsive: false,
      onClick: handleButtonClick,
      buttonRef: buttonRef,
      loading: isCloning,
      failed: isCloningFailed,
      disabled: isCloning,
      size: "extra-small",
      spinnerProps: {
        'data-test-id': 'clone-button-spinner'
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.cloneButton.text"
      })
    })
  );
};
export function showCloneButton(quote, canCurrentUserEditQuote) {
  const hasStatus = !!getQuoteProperty(quote, 'hs_status');
  const hasDeal = getHasDeal(quote);
  const isCloneable = hasStatus && hasDeal;
  return isCloneable && !getIsPublishing(quote) && canCurrentUserEditQuote;
}
export default CloneButton;